import { render, staticRenderFns } from "./ExportacaoCissPoder.vue?vue&type=template&id=226507ec"
import script from "./ExportacaoCissPoder.vue?vue&type=script&lang=js"
export * from "./ExportacaoCissPoder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports